import i18n from '@i18n';
import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    office_id: yup.string().required(i18n.t('VALIDATION.REQUIRED')),
    group_for: yup.object().nullable().required(i18n.t('VALIDATION.REQUIRED')),
    isTransfered: yup.number().min(1).required(i18n.t('VALIDATION.REQUIRED')),
  });
